import { render, staticRenderFns } from "./OverviewTimelineRound.vue?vue&type=template&id=28c5a208&"
import script from "./OverviewTimelineRound.vue?vue&type=script&lang=js&"
export * from "./OverviewTimelineRound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports